import { dataHooks } from '@wix/data-hooks'

export const wixStudioSimpleSplitDataHooks = dataHooks<{
  title: {}
  text: {}
  option: { id: string }
}>('wixStudioSimpleSplit')
